import { createApp, h } from 'vue'
import ServerUpdating from './components/index.vue'
/**
 * 服务器正在更新时，弹出全屏提示窗口的方法
 * 在socket和api中被调用
 * @returns
 */
export const showServerUpdating = () => {
  let el = document.getElementById('server-updating')
  if (el) return null
  const dom = document.createElement('div')
  dom.id = 'server-updating'
  const appEl = document.getElementById('app') as HTMLElement
  appEl.appendChild(dom)
  const serverUpdatingInstance = h(ServerUpdating)
  const app = createApp({
    render() {
      return serverUpdatingInstance
    }
  })
  app.mount(dom)
  let autoCloseTimer: any = null
  let pollingTimer: any = null
  console.log(pollingTimer)

  // 超过4分钟 自动关闭
  autoCloseTimer = setTimeout(
    () => {
      console.log('还在执行autoCloseTimer')
      closeMask()
    },
    60 * 1000 * 3
  )
  const closeMask = () => {
    let el = document.getElementById('server-updating')
    if (!el) return
    serverUpdatingInstance.component?.exposed?.['doneProgress']?.()
    autoCloseTimer && clearTimeout(autoCloseTimer)
    autoCloseTimer = null
    setTimeout(() => {
      // 销毁组件 刷新当前页面
      app.unmount()
      dom.remove()
      // router.go(0);  //safari不支持
      window.location.reload()
    }, 300)
  }
}
